<script setup lang="ts">
  import type { IconComponent } from '@gat-ship/icons'
  import { IconLoading } from '@gat-ship/icons'

  defineProps<{
    icon: IconComponent
    loading?: boolean
  }>()
</script>

<template>
  <div
    class="bg-background shadow-xs ring-border flex size-10 shrink-0 items-center justify-center rounded-full ring-1 ring-inset"
  >
    <IconLoading v-if="loading" class="size-4" />
    <component :is="icon" v-else class="lucide-icon size-4 shrink-0" />
  </div>
</template>
